import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Импортируем ресурсы перевода с правильного пути
import enTranslation from './locales/en.json';
import ruTranslation from './locales/ru.json';
import ukTranslation from './locales/uk.json';
import idTranslation from './locales/id.json';

// Инициализируем i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      ru: {
        translation: ruTranslation
      },
      uk: {
        translation: ukTranslation
      },
      id: {
        translation: idTranslation
      }
    },
    lng: localStorage.getItem('user_lang') || 'ru', // язык по умолчанию
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;